import { NextPage } from 'next';

const Index: NextPage = () => {
  return <p>Nothing here</p>;
};

export default Index;
